export const EMPLOYEES_UPDATE_ALL_EMPLOYEES = 'employees.UPDATE_ALL_EMPLOYEES';
export const EMPLOYEES_UPDATE_HIRED_EMPLOYEES = 'employees.UPDATE_HIRED_EMPLOYEES';

export const EMPLOYEES_HIRE = 'employees.HIRE';
export const EMPLOYEES_FIRE = 'employees.FIRE';

export const EMPLOYEES_ENABLE_AUTO_FUNCTIONING = 'employees.ENABLE_AUTO_FUNCTIONING';
export const EMPLOYEES_LOAD_AUTOMATED = 'employees.LOAD_AUTOMATED';

export const EMPLOYEES_UPDATE_WORK_STATUS_IN_PROGRESS = 'employees.UPDATE_WORK_STATUS_IN_PROGRESS';
export const EMPLOYEES_UPDATE_WORK_STATUS_DONE = 'employees.UPDATE_WORK_STATUS_DONE';
export const EMPLOYEES_RESET_WORK_STATUS = 'employees.RESET_WORK_STATUS';
export const EMPLOYEES_UPDATE_CAN_WORK_WITH_VIEWING_CUSTOMERS =
	'employee.UPDATE_CAN_WORK_WITH_VIEWING_CUSTOMERS';
